<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('water.title') }}</div>
                    </van-col>
                    <van-col span="6" @click="toSetTarget">
                        <img class="right-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/10set.svg`)">
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time3'))">{{ $t('dailyActive.time3') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 2}" @click="changeTimeType(2, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 3}" @click="changeTimeType(3, $t('dailyActive.time2'))">{{ $t('dailyActive.time2') }}</div>
            </div>
            <div class="box">
                <div class="time-select">
                    <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                    <div class="time-date">{{ time }}</div>
                    <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
                    <div class="chart-unit" v-if="mathData.maxData && activeTime != 0">ml</div>
                </div>
                <div v-if="activeTime == 0" class="chart-box">
                    <!-- 圆环 -->
                    <svg id="myCanvas">
                        <circle
                            fill="none"
                            :cx="cx"
                            :cy="cx"
                            :r="r"
                            stroke="var(--water-circle-color)"
                            :stroke-width="strokeWidth"
                        />
                        <path
                            fill="none"
                            :d="d"
                            stroke="var(--chart-color-8)"
                            stroke-width="10"
                            :stroke-dasharray="circleDashArray"
                            stroke-linecap="round"
                            :style="{ transition: 'stroke-dashoffset .5s linear 0s, stroke-dasharray .5s linear 0s, stroke .5s, stroke-width .5s linear .5s' }"
                        />
                    </svg>
                    <!--                    <canvas id="myCanvas"></canvas>-->
                    <div class="wave-progress">
                        <div class="wave"></div>
                        <canvas width="111" height="111" id="canvas"></canvas>
                    </div>
                    <div class="wave-text1">{{ $t('water.today') }}</div>
                    <div class="wave-text2">{{ todayWater }}</div>
                    <div class="wave-text3">{{ $t('water.surplus') }}{{ surplus }}ml</div>
                    <img :class="{'arr-opacity' : tNum !== 0}" class="add-icon" src="@/assets/theme/light/status/18water/02add.svg" @click="changeWater(0)">
                    <img :class="{'arr-opacity' : tNum !== 0}" class="reduce-icon" src="@/assets/theme/light/status/18water/03reduce.svg"
                         @click="changeWater(1)">
                    <div class="ratio-box">{{ $t('water.math2') }}：{{ ratioNum > 0 ? ratioNum.toFixed(1) : ratioNum }}%</div>
                </div>
                <div v-show="activeTime != 0" id="chart-box"></div>
            </div>
            <div class="math-box" v-if="activeTime == 1 || activeTime == 2">
                <van-row>
                    <van-col span="8">
                        <div class="math-item">
                            <div class="math-num">{{
                                    mathData.maxData ? format(mathData.maxData) :
                                        '--'
                                }}
                            </div>
                            <div class="math-text">{{ $t('water.math0') }}</div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="math-item">
                            <div class="math-num">{{
                                    mathData.minData ?
                                        format(parseInt(mathData.minData)) :
                                        '--'
                                }}
                            </div>
                            <div class="math-text">{{ $t('water.math1') }}</div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="math-item">
                            <div class="math-num">{{ mathData.maxData ? parseInt(mathData.percentage * 100) : '--' }}
                                <span
                                    v-if="mathData.maxData">%</span></div>
                            <div class="math-text">{{ $t('water.math2') }}</div>
                        </div>
                    </van-col>
                </van-row>
            </div>
            <div class="math-box" v-if="activeTime == 3">
                <van-row>
                    <van-col span="12">
                        <div class="math-item">
                            <div class="math-num">{{
                                    mathData.maxData ? format(mathData.maxData) :
                                        '--'
                                }}
                            </div>
                            <div class="math-text">{{ $t('water.math3') }}</div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="math-item">
                            <div class="math-num">{{
                                    mathData.minData ?
                                        format(parseInt(mathData.minData)) :
                                        '--'
                                }}
                            </div>
                            <div class="math-text">{{ $t('water.math4') }}</div>
                        </div>
                    </van-col>
                </van-row>
            </div>
            <div class="desc-box">
                <div class="desc-title">{{ $t('water.descTitle') }}</div>
                <div class="desc-info last-desc">{{ $t('water.desc') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    changeDate,
    changeMonthDate,
    GetDateStr,
    getMonthEndDay,
    getMonthStartDay,
    getNWeekFirstDay,
    getNWeekLastDay, getToday, GetYear
} from "../../utils/dateUtils";
import {WebJSBridge} from "../../utils/JSBridge1";
import {getSkin} from "@/utils/comment";
import {format} from '@/utils/math'
import {getWaterCount, getWaterCountList} from "../../api/status";
import { Toast } from 'vant'

export default {
    name: 'water',
    data() {
        return {
            ratio: 1,
            theme: '',
            activeTime: 0,
            timeUnit: '',
            time: '',
            startDate: '',
            endDate: '',
            tNum: 0,
            wNum: 0,
            mNum: 0,
            yNum: 0,
            mathData: {},
            chartData: {
                date: [],
                value: [],
                target: [],
            },
            showTimeBox: false,
            showLeftOpacity: 0,
            showRightOpacity: 1,
            todayWater: '', // 今日饮水量
            surplus: '', // 剩余饮水量
            cup: '', // 杯子容量
            targetWater: '', // 目标饮水量
            circleDashArray: '', // svg
            cx: 75, // svg 中心坐标
            strokeWidth: 10, // svg 圆宽
            r: 65, // svg 半径
            d: '', // Svg path 路径
            percentage: 0, // 圆环进度
            ratioNum: '', // 目标完成率
            wavePercentage: 0, // 水波进度
        }
    },
    watch: {
        showTimeBox: {
            handler(newVal, olVal) {
                if (newVal) {
                    setTimeout(() => {
                        document.addEventListener('click', this.checkClick);
                    }, 0);
                } else {
                    document.removeEventListener('click', this.checkClick);
                }
            }
        }
    },

    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.cx = this.ratio * 75;
        this.strokeWidth = this.ratio * 10;
        this.r = this.ratio * 65;
        let cy = this.ratio * 140;
        this.d = 'M ' + this.cx + ', ' + this.strokeWidth + ' A ' + this.r + ', ' + this.r + ', 0, 0, 1, ' + this.cx + ', ' + cy + ' A ' + this.r + ', ' + this.r + ', 0, 0, 1, ' + this.cx + ', ' + this.strokeWidth;
        this.theme = this.$route.query.theme ? this.$route.query.theme : 'light';
        this.timeUnit = this.$t('sleep.time0');
        this.startDate = getToday();
        this.endDate = getToday();
        this.time = getToday().slice(5, 10).replace(/-/g, '/');
        this.setProgress();
        this.getData();
    },
    methods: {
        checkClick(event) {
            let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
            if (!dom.contains(event.target)) {
                // 不在菜单范围，隐藏即可
                if (this.showTimeBox) {
                    this.showTimeBox = false;
                    document.removeEventListener('click', this.checkClick);
                }
            }
        },
        waveInit() {
            let ratio = this.todayWater / this.targetWater > 1 ? 1 : this.todayWater / this.targetWater;
            this.ratioNum = ratio * 100; // 完成比例百分数
            if (this.ratioNum > this.percentage) {
                let current = this.percentage;
                let end = this.ratioNum;
                let timer = setInterval(() => {
                    if (current < end) {
                        current = current + 1;
                    }
                    if (current >= end) {
                        current = end;
                        clearInterval(timer);
                    }
                    this.percentage = current;
                    this.wavePercentage = current;
                    this.setProgress()
                }, 20);
            } else {
                let current = this.percentage;
                let end = this.ratioNum;
                let timer = setInterval(() => {
                    if (current > end) {
                        current = current - 1;
                    }
                    if (current <= end) {
                        current = end;
                        clearInterval(timer);
                    }
                    this.percentage = current;
                    this.wavePercentage = current;
                    this.setProgress()
                }, 20);
            }
        },
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        checkOpacity() {
            if (this.activeTime === 0 && this.tNum <= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime === 1 && this.wNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime === 2 && this.mNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime === 3 && this.yNum >= 0) {
                this.showRightOpacity = 1
            } else {
                this.showRightOpacity = 0
            }
            if (this.activeTime === 0 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime === 1 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime === 2 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime === 3 && GetYear(this.yNum - 1) <= 2024) {
                this.showLeftOpacity = 1
            } else {
                this.showLeftOpacity = 0
            }
        },
        timeLeft() {
            if (this.showLeftOpacity === 1) {
                return
            }
            if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                this.tNum++;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                this.wNum--;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                this.mNum--;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            } else if (this.activeTime == 3 && GetYear(this.yNum - 1) > 2024) {
                this.yNum--;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        timeRight() {
            if (this.showRightOpacity === 1) {
                return
            }
            if (this.activeTime == 0 && this.tNum > 0) {
                this.tNum--;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.wNum < 0) {
                this.wNum++;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.mNum < 0) {
                this.mNum++;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            } else if (this.activeTime == 3 && this.yNum < 0) {
                this.yNum++;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        changeTimeType(num, unit) {
            this.activeTime = num;
            this.timeUnit = unit;
            this.showTimeBox = false;
            if (this.activeTime == 1) {
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 2) {
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            if (this.activeTime == 3) {
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            if (this.activeTime == 0) {
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            }
            this.getData();
            this.checkOpacity();
        },
        handleAdd(n) {
            this.percentage = n;
            this.setProgress();
        },
        handleMinum(n) {
            this.percentage = n;
            this.setProgress();
        },
        setProgress() {
            // 圆环
            const girth = 2 * Math.PI * this.r;
            this.circleDashArray = `${this.percentage * 0.01 * girth} ${girth}`;
        },
        changeWater(tag) {
            if (this.tNum !== 0) {
                return
            }
            if (tag === 1) { // 减
                if (this.todayWater - this.cup >= 0) {
                    this.todayWater = this.todayWater - this.cup;
                    this.surplus = (this.targetWater - this.todayWater) > 0 ? this.targetWater - this.todayWater : 0;
                    let ratio = this.todayWater / this.targetWater > 1 ? 1 : this.todayWater / this.targetWater;
                    this.ratioNum = ratio * 100; // 完成比例百分数
                    this.handleMinum(this.ratioNum);
                    let current = this.wavePercentage;
                    let end = this.ratioNum;
                    let timer = setInterval(() => {
                        if (current > end) {
                            current = current - 1;
                        }
                        if (current <= end) {
                            current = end;
                            clearInterval(timer);
                        }
                        this.wavePercentage = current;
                    }, 20);
                } else {
                    this.todayWater = 0;
                }
            } else { // 加
                if (this.todayWater + this.cup > 9900) {
                    Toast(this.$t('water.maxCountDesc'))
                    return;
                }
                this.todayWater = this.todayWater + this.cup;
                this.surplus = (this.targetWater - this.todayWater) > 0 ? this.targetWater - this.todayWater : 0;
                let ratio = this.todayWater / this.targetWater > 1 ? 1 : this.todayWater / this.targetWater;
                this.ratioNum = ratio * 100; // 完成比例百分数
                this.handleAdd(this.ratioNum)
                let current = this.wavePercentage;
                let end = this.ratioNum;
                let timer = setInterval(() => {
                    if (current < end) {
                        current = current + 1;
                    }
                    if (current >= end) {
                        current = end;
                        clearInterval(timer);
                    }
                    this.wavePercentage = current;
                }, 20);
            }
            this.uploadWater();
        },
        getData() {
            if (this.activeTime == 0) {
                this.$api.status.getWaterCount({
                    date: this.startDate,
                }).then(res => {
                    if (res.result == 1) {
                        this.todayWater = res.info.waterCount ? res.info.waterCount : 0;
                        this.targetWater = res.info.waterTarget ? res.info.waterTarget : 2000;
                        this.surplus = (this.targetWater - this.todayWater) > 0 ? this.targetWater - this.todayWater : 0;
                        this.cup = res.info.onceWaterCount;
                        this.$nextTick(() => {
                            this.init();
                            this.waveInit();
                        })
                    }
                })
            } else if (this.activeTime == 3) {
                this.$api.status.getWaterCountYear({
                    year: this.startDate,
                }).then(res => {
                    if (res.result == 1) {
                        this.mathData = {
                            maxData: res.info.max,
                            minData: res.info.min,
                            percentage: res.info.percentage
                        };
                        this.chartData.date = [];
                        this.chartData.value = [];
                        this.chartData.target = [];
                        for (let i = 0; i < res.info.waterCountList.length; i++) {
                            let date;
                            let value = res.info.waterCountList[i].waterCount ? res.info.waterCountList[i].waterCount : 0;
                            let target = res.info.waterCountList[i].waterTarget ? res.info.waterCountList[i].waterTarget : 2000;
                            date = i + 1;
                            this.chartData.date.push(date);
                            this.chartData.value.push(value);
                            this.chartData.target.push(target);
                        }
                        this.drawChart(getSkin('--chart-color-8'), getSkin('--chart-color-11'));
                    }
                })
            } else {
                this.$api.status.getWaterCountList({
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.mathData = {
                            maxData: res.info.max,
                            minData: res.info.min,
                            percentage: res.info.percentage
                        };
                        this.chartData.date = [];
                        this.chartData.value = [];
                        this.chartData.target = [];
                        for (let i = 0; i < res.info.waterCountList.length; i++) {
                            let date;
                            let value = res.info.waterCountList[i].waterCount ? res.info.waterCountList[i].waterCount : 0;
                            let target = res.info.waterCountList[i].waterTarget ? res.info.waterCountList[i].waterTarget : 2000;
                            date = changeDate(res.info.waterCountList[i].date)
                            this.chartData.date.push(date);
                            this.chartData.value.push(value);
                            this.chartData.target.push(target);
                        }
                        console.log(this.chartData)
                        this.drawChart(getSkin('--chart-color-8'), getSkin('--chart-color-11'));
                    }
                })
            }
        },
        drawChart(color1, color2) {
            if (!this.myChart) {
                this.myChart = this.$echarts.init(document.getElementById("chart-box"));
            }
            let barWidth = 10 * this.ratio;
            if (this.activeTime == 2) {
                barWidth = 4 * this.ratio;
            } else {
                barWidth = 10 * this.ratio;
            }
            let _this = this;
            if (this.mathData.maxData == 0) {
                this.myChart.setOption({
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 76 * this.ratio,
                        textStyle: {
                            fontFamily: 'SF',
                            fontSize: 12 * this.ratio,
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 20 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio,
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            fontFamily: 'D-D',
                            color: getSkin('--text-color-3')
                        },
                        data: this.chartData.date
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        boundaryGap: [0, '10%'],
                        axisLabel: false,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        }
                    },
                    series: [
                        {
                            data: this.chartData.value,
                            type: 'bar',
                            symbol: 'none',
                            smooth: false,
                            barWidth: barWidth,
                            itemStyle: {
                                color: color1,
                                borderRadius: [5, 5, 0, 0],
                            },
                            emphasis: {
                                itemStyle: {
                                    color: color2,
                                    borderRadius: [5, 5, 0, 0],
                                },
                            },
                            lineStyle: {
                                width: 3
                            }
                        }
                    ]
                }, true);
            } else {
                this.myChart.setOption({
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio,
                    },
                    xAxis: {
                        type: 'category',
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            fontFamily: 'D-D',
                            color: getSkin('--text-color-3')
                        },
                        data: this.chartData.date
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        boundaryGap: [0, '10%'],
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            fontFamily: 'D-D',
                            color: getSkin('--text-color-3'),
                            formatter: function (value) {
                                if (value >= 1000) {
                                    value = value / 1000
                                    if (/^\d+$/.test(value)) {
                                        return value + 'k';
                                    } else {
                                        return value.toFixed(1) + 'k';
                                    }
                                } else if (value >= 1000000) {
                                    value = value / 1000000
                                    if (/^\d+$/.test(value)) {
                                        return value + 'M';
                                    } else {
                                        return value.toFixed(1) + 'M';
                                    }
                                } else {
                                    return value
                                }
                            },
                            showMinLabel: false
                        },
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        }
                    },
                    tooltip: {
                        backgroundColor: getSkin('--bg-color-2'),
                        trigger: 'axis',
                        axisPointer: {
                            type: 'line'
                        },
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[1];
                            let value = format(item.data);
                            if (item.data == 0) {
                                return
                            }
                            let unit = 'ml';
                            let html = '';
                            let arrIndex = item.axisValue - 1;
                            let monthArr = _this.$t('monthArr');
                            let month = _this.activeTime == 3 ? monthArr[arrIndex] + _this.$t('water.chartUnit') : item.axisValue;
                            html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + month + '</div>'
                            html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span> ' + unit + '</div>'
                            return html
                        }
                    },
                    series: [
                        {
                            data: this.chartData.target,
                            type: 'bar',
                            symbol: 'none',
                            smooth: false,
                            barWidth: barWidth,
                            itemStyle: {
                                color: '#DFE2E8',
                                borderRadius: [5, 5, 0, 0],
                            },
                            emphasis: {
                                itemStyle: {
                                    color: '#DFE2E8',
                                    borderRadius: [5, 5, 0, 0],
                                },
                            }
                        },
                        {
                            data: this.chartData.value,
                            type: 'bar',
                            symbol: 'none',
                            smooth: false,
                            barWidth: barWidth,
                            barGap: "-100%",
                            itemStyle: {
                                color: color1,
                                borderRadius: [5, 5, 0, 0],
                            },
                            emphasis: {
                                itemStyle: {
                                    color: color2,
                                    borderRadius: [5, 5, 0, 0],
                                },
                            },
                        }
                    ]
                }, true);
            }
        },
        format(num) {
            return format(num)
        },
        drawCircle(ctx, mW, color) {
            ctx.beginPath();
            ctx.strokeStyle = color;
            ctx.arc(mW / 2, mW / 2, mW / 2, 0, 2 * Math.PI);
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(mW / 2, mW / 2, mW / 2, 0, 2 * Math.PI);
            ctx.clip();
        },
        drawSin(ctx, mW, color1, color2, wav, dY) {
            ctx.save();
            // var lineargradient = ctx.createLinearGradient(0, 150, 200, 150); // 创建一个线性渐变
            // lineargradient.addColorStop(0, color1);
            // lineargradient.addColorStop(1, color2);
            ctx.beginPath();
            ctx.moveTo(0, mW);
            ctx.lineTo(0, dY);
            // ctx.bezierCurveTo(mW / 4, dY - wav, (mW *3) / 4, dY + wav, mW, dY);
            ctx.quadraticCurveTo(mW / 4, dY - wav, mW / 2, dY);
            ctx.lineTo(mW / 2, dY)
            ctx.quadraticCurveTo((mW * 3) / 4, dY + wav, mW, dY);
            //  ctx.stroke();
            ctx.lineTo(mW, mW);
            ctx.lineTo(0, mW);
            ctx.fillStyle = color1;
            // ctx.fillRect(0, 0, 200, 150)
            ctx.fill();
            ctx.restore();
        },
        init() {
            let _this = this;
            var canvas1 = document.getElementById('canvas')

            var mW = 111 * _this.ratio;
            // console.log(mW);
            // 设置Canvas元素的高
            canvas1.style.height = mW;
            // 设置Canvas画布的宽高
            canvas1.width = canvas1.height = mW;

            var canvas2 = document.createElement('canvas'),
                ctx2 = canvas2.getContext('2d');
            canvas2.width = mW;
            canvas2.height = mW;

            var canvas3 = document.createElement('canvas'),
                ctx3 = canvas3.getContext('2d');
            canvas3.width = mW;
            canvas3.height = mW;

            var x = 0, flat = 400, speed = 2, rate = 0, distance = 200, wave = 0


            var ctx1 = canvas1.getContext('2d')

            this.drawCircle(ctx1, mW, 'transparent');
            this.drawSin(ctx2, mW, 'rgba(0, 185, 255, 0.2)', '#B5E5FF', wave, mW - mW * rate);
            this.drawSin(ctx3, mW, 'rgba(0, 185, 255, 0.2)', '#CCF1FF', wave, mW - mW * rate);
            //  ctx1.drawImage(canvas2, 0, 0)

            var rate1 = rate, wave1 = wave

            function animation() {
                rate = parseInt(_this.wavePercentage) / 100
                if (rate === 0 || rate === 1) {
                    wave = 0
                } else {
                    wave = 30
                }

                if (rate !== rate1 || wave1 !== wave) {
                    ctx2.clearRect(0, 0, mW, mW)
                    ctx3.clearRect(0, 0, mW, mW)
                    rate1 = rate
                    wave1 = wave
                    _this.drawSin(ctx2, mW, 'rgba(0, 185, 255, 0.2)', '#B5E5FF', wave, mW - mW * rate);
                    _this.drawSin(ctx3, mW, 'rgba(0, 185, 255, 0.2)', '#CCF1FF', wave, mW - mW * rate);
                }

                ctx1.clearRect(0, 0, mW, mW)
                ctx1.drawImage(canvas2, x, 0, mW + flat, mW)
                ctx1.drawImage(canvas2, x - mW - flat, 0, mW + flat, mW)
                ctx1.drawImage(canvas3, x - distance, 0, mW + flat, mW)
                ctx1.drawImage(canvas3, x - mW - distance - flat, 0, mW + flat, mW)
                x >= (mW - speed + flat) ? x = 0 : x += speed
                requestAnimationFrame(animation)
            }
            animation()
        },
        uploadWater() {
            this.$api.status.uploadWater({
                date: this.startDate,
                waterTarget: this.targetWater,
                waterCount: this.todayWater
            }).then(res => {
                WebJSBridge.call("updateWater", {
                    'waterCount': this.todayWater
                }, function (res) {
                });
            })
        },
        toSetTarget() {
            this.$router.push({
                name: 'waterSet',
                query: {
                    lang: this.$i18n.locale,
                    theme: this.theme,
                }
            })
        }
    },
    unmounted() {
        document.removeEventListener('click', this.checkClick);
    }
}
</script>

<style scoped>

.box {
    width: 100%;
    height: 210px;
}

.chart-box {
    width: 100%;
    margin-top: 16px;
    height: 145px;
    position: relative;
}

#myCanvas {
    width: 150px;
    height: 150px;
    position: absolute;
    left: 112.5px;
    top: 0;
}

@keyframes spin {
    50% {
        transform: translate(-50%, -100%) rotate(45deg);
    }
    100% {
        transform: translate(-50%, -100%) rotate(90deg);
    }
}

.wave-progress {
    width: 111px;
    height: 111px;
    border-radius: 50%;
    position: absolute;
    left: 132px;
    top: 20px;
}

.wave-mask-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 50%;
    background: transparent;
}

.wave {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: 1px 1px 8px 1px var(--shadow-color-1);
}

#canvas {
    position: absolute;
    top: 0;
    left: 0;
}

#wave-mask {
    position: absolute;
    width: 200%;
    height: 200%;
    top: 50%;
    left: 50%;
    border-radius: 40%;
    transform: translate(-50%, -100%) rotate(0);
    animation: spin 2s linear;
    background-color: var(--bg-color-2);
}

.add-icon {
    width: 24px;
    position: absolute;
    top: 63px;
    right: 55px;
}

.reduce-icon {
    width: 24px;
    position: absolute;
    top: 63px;
    left: 55px;
}

.wave-text1 {
    color: var(--text-color-1);
    font-size: 12px;
    text-align: center;
    width: 375px;
    position: absolute;
    top: 44px;
}

.wave-text2 {
    color:var(--text-color-1);
    font-size: 32px;
    text-align: center;
    top: 55px;
    position: absolute;
    width: 375px;
}

.wave-text3 {
    color: var(--text-color-2);
    font-size: 12px;
    text-align: center;
    top: 96px;
    position: absolute;
    width: 375px;
}

.ratio-box {
    color: var(--text-color-2);
    font-size: 12px;
    text-align: center;
    top: 155px;
    position: absolute;
    width: 375px;
}

#chart-box {
    height: 198px;
    width: 100%;
}

.chart-unit {
    position: absolute;
    font-size: 11px;
    color: var(--text-color-3);
    left: 15px;
    top: 22px;
    line-height: 12px;
}

</style>


// WEBPACK FOOTER //
// src/views/status/18water.vue